import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { EventParticipantStatusEnum } from 'src/shared/models/enums/eventParticipantStatus.enum';

type EventParticipantStatusesProps = {
  status: EventParticipantStatusEnum | null | undefined;
  chipSize: 'small' | 'medium' | undefined;
  ticketRedeemed?: boolean | undefined;
};

export const EventParticipantStatuses = (props: EventParticipantStatusesProps) => {
  const { status, chipSize, ticketRedeemed } = props;
  const { t } = useTranslation();

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status !== undefined && status === EventParticipantStatusEnum.Unanswered && (
        <Tooltip describeChild title={`${t('event:participantStatuses.unanswered')}`} arrow>
          <CustomChip label={t('event:participantStatuses.unanswered')} color='grey' size={chipSize} />
        </Tooltip>
      )}
      {status !== undefined && status === EventParticipantStatusEnum.Attending && (
        <Tooltip describeChild title={`${t('event:participantStatuses.attending')}`} arrow>
          <CustomChip label={t('event:participantStatuses.attending')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status !== undefined && status === EventParticipantStatusEnum.NotAttending && (
        <Tooltip describeChild title={`${t('event:participantStatuses.notAttending')}`} arrow>
          <CustomChip label={t('event:participantStatuses.notAttending')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {status !== undefined && status === EventParticipantStatusEnum.Cancelled && (
        <Tooltip describeChild title={`${t('event:participantStatuses.cancelled')}`} arrow>
          <CustomChip label={t('event:participantStatuses.cancelled')} color='error' size={chipSize} />
        </Tooltip>
      )}

      {status === undefined && ticketRedeemed !== undefined && ticketRedeemed && (
        <Tooltip describeChild title={`${t('event:participantStatuses.redeemed')}`} arrow>
          <CustomChip label={t('event:participantStatuses.redeemed')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status === undefined && ticketRedeemed !== undefined && !ticketRedeemed && (
        <Tooltip describeChild title={`${t('event:participantStatuses.notRedeemed')}`} arrow>
          <CustomChip label={t('event:participantStatuses.notRedeemed')} color='error' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
